import { AxiosResponse } from "axios";
import { useQuery } from 'react-query';
import apiClient from "../apiClient/apiClient";
import { CouponType } from "./coupon.type";


export const useCoupons = () => {
    return useQuery<AxiosResponse<CouponType[]>>('coupons', () => apiClient.get<CouponType[]>('/coupons'))
}